module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_AIG.8f0b0817.gif";